import { render, staticRenderFns } from "./GetInvoiceJournalReportData.vue?vue&type=template&id=3b6fd0fd&scoped=true&"
import script from "./GetInvoiceJournalReportData.vue?vue&type=script&lang=js&"
export * from "./GetInvoiceJournalReportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fd0fd",
  null
  
)

export default component.exports